export default '/build/649fee90.svg'